import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgBot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={1.5} y={5.5} width={13} height={9} rx={1.5} stroke="#919499" />
    <path
      d="M11.5 8.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-5 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
      stroke="#919499"
    />
    <path
      clipRule="evenodd"
      d="M8 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      stroke="#919499"
    />
    <path d="M5 11s1.2 1 3 1 3-1 3-1M8 5.765V3" stroke="#919499" />
  </svg>
);
const Memo = memo(SvgBot);
export default Memo;
